<template>
  <transition name="slide-fade" v-if="!isEmbedded">
    <mobile-menu v-if="isMenuOpen" @menu="toggleMenu" class="fixed lg:hidden" />
  </transition>
  <Header v-if="!isEmbedded" @menu="toggleMenu" ref="header" />
  <div
    ref="container"
    :style="isEmbedded ? '' : 'min-height: calc(100vh - 120px); transition: min-height 0.5s ease-in-out;'"
  >
    <slot />
  </div>
  <Footer v-if="!isEmbedded" ref="footer" />
</template>

<script setup>
const header = ref(null);
const footer = ref(null);
const container = ref(null);

const isMenuOpen = ref(false);
const isEmbedded = ref(false);

function toggleMenu(v) {
  isMenuOpen.value = v;
}
let resizeObserver = null;

function reportHeightToParent() {
  window.parent.postMessage(
    { source: "prenatal-card-iframe", height: container.value.scrollHeight },
    "*"
  );
}

function openLinksInNewTab(event) {
  const anchor = event.target.closest("a");
  if (!anchor || !anchor.href) return;

  const href = anchor.getAttribute("href");
  if (!href || /^(#|mailto:|tel:|javascript:)/i.test(href)) return;

  event.preventDefault();
  event.stopPropagation();
  window.open(anchor.href, "_blank", "noopener,noreferrer");
}

onMounted(async () => {
  isEmbedded.value = window.self !== window.top;

  if (isEmbedded.value) {
    await nextTick();
    reportHeightToParent();
    resizeObserver = new ResizeObserver(reportHeightToParent);
    resizeObserver.observe(container.value);
    container.value.addEventListener("click", openLinksInNewTab, true);
    return;
  }

  await nextTick();
  const height = header.value.$el.clientHeight + footer.value.$el.clientHeight;
  container.value.style.minHeight = "calc(100vh - " + height + "px)";
});

onUnmounted(() => {
  resizeObserver?.disconnect();
  container.value?.removeEventListener("click", openLinksInNewTab, true);
});
</script>
